/**
 * MyBouddha Stone Quiz
 * Native Shopify quiz replacing TypeForm + instant.so
 */

(function () {
  'use strict';

  /* =========================================================
     STONE DATA — 25 stones with full content
     ========================================================= */
  const STONES = [
    {
      slug: 'amethyste',
      name: 'Améthyste',
      article: "l'",
      tagline: 'Paix intérieure, sérénité retrouvée',
      reading: "Vous traversez une phase de tension émotionnelle, un sentiment de repli, ou une perte d'élan vital. Votre énergie actuelle montre un besoin de réconfort, d'ouvrir votre cœur, ou de restaurer une paix intérieure longtemps négligée.",
      description: "Elle ne promet pas de tout guérir, mais de ramener la douceur là où il y a eu crispation. Elle calme les émotions, adoucit les blessures, et invite à une transformation intérieure paisible.",
      chakra: { name: 'Couronne', sanskrit: 'Sahasrara', description: 'Le centre de votre connexion spirituelle et de votre éveil intérieur.' },
      element: { name: 'Air', description: "Légèreté, clarté et élévation de l'esprit." },
      virtues: ['Sérénité', 'Intuition', 'Sommeil'],
      collectionHandle: 'amethyste',
      color: '#9b59b6',
      image: 'pierre-amethyste.png',
      affirmation: 'Je suis en paix avec moi-même. Je laisse la sérénité guider chacun de mes pas.'
    },
    {
      slug: 'lapis-lazuli',
      name: 'Lapis Lazuli',
      article: 'le ',
      tagline: "La sagesse intérieure, la voix de l'âme",
      reading: "Vous ressentez un brouillard mental, un besoin de clarté ou de reconnexion à votre vérité profonde. Votre énergie cherche à s'aligner avec votre intuition et votre sagesse intérieure.",
      description: "Le Lapis Lazuli est la pierre qui vous appelle. Elle ouvre les portes de la perception, clarifie l'esprit et vous aide à exprimer votre vérité avec confiance.",
      chakra: { name: 'Troisième œil', sanskrit: 'Ajna', description: "Le centre de votre intuition et de votre clairvoyance." },
      element: { name: 'Eau', description: "Fluidité, intuition et profondeur émotionnelle." },
      virtues: ['Clarté', 'Intuition', 'Sagesse'],
      collectionHandle: 'lapis-lazuli',
      color: '#1E4D8C',
      image: 'pierre-lapis-lazuli.png',
      affirmation: 'Je fais confiance à ma sagesse intérieure. Ma vérité me guide avec clarté.'
    },
    {
      slug: 'malachite',
      name: 'Malachite',
      article: 'la ',
      tagline: 'La transformation, le renouveau intérieur',
      reading: "Vous vous sentez instable, stressé(e), ou bloqué(e) par des énergies négatives. Votre énergie a besoin d'ancrage, de stabilité et de protection pour avancer sereinement.",
      description: "La Malachite est la pierre qui vous appelle. Puissante pierre de transformation, elle absorbe les énergies négatives et vous aide à briser les schémas qui vous retiennent.",
      chakra: { name: 'Coeur', sanskrit: 'Anahata', description: "Le centre de votre amour, de votre compassion et de votre équilibre émotionnel." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Protection', 'Transformation', 'Ancrage'],
      collectionHandle: 'malachite',
      color: '#2d8659',
      image: 'pierre-malachite.png',
      affirmation: 'Je me libère de ce qui ne me sert plus. Chaque jour, je me transforme et je grandis.'
    },
    {
      slug: 'onyx',
      name: 'Onyx',
      article: "l'",
      tagline: 'La force intérieure, le bouclier protecteur',
      reading: "Vous ressentez le besoin de vous recentrer, de retrouver votre calme intérieur face au stress et aux énergies qui vous déstabilisent. Vous cherchez un apaisement profond.",
      description: "L'Onyx est la pierre qui vous appelle. C'est un bouclier puissant qui absorbe les négativités et renforce votre détermination intérieure.",
      chakra: { name: 'Racine', sanskrit: 'Muladhara', description: "Le centre de votre ancrage et de votre stabilité fondamentale." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Protection', 'Force', 'Ancrage'],
      collectionHandle: 'nos-bijoux-en-pierre-onyx',
      color: '#2c2c2c',
      image: 'pierre-onyx.png',
      affirmation: 'Je suis fort(e) et protégé(e). Rien ne peut ébranler ma paix intérieure.'
    },
    {
      slug: 'aventurine-verte',
      name: 'Aventurine Verte',
      article: "l'",
      tagline: "L'harmonie du cœur, la croissance dans la douceur",
      reading: "Vous traversez une phase de tension émotionnelle, un sentiment de repli, ou une perte d'élan vital. Votre énergie actuelle montre un besoin de réconfort, d'ouvrir votre cœur, ou de restaurer une paix intérieure longtemps négligée.",
      description: "L'Aventurine verte est la pierre qui vous appelle. Elle ne promet pas de tout guérir, mais de ramener la douceur là où il y a eu crispation. Elle calme les émotions, adoucit les blessures, et invite à une transformation intérieure paisible.",
      chakra: { name: 'Coeur', sanskrit: 'Anahata', description: "Le centre de votre amour, de votre compassion et de votre équilibre émotionnel." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Apaisement', 'Confiance', 'Ouverture Emotionnelle'],
      collectionHandle: 'nos-bijoux-en-pierre-aventurine-verte',
      color: '#3a7d5c',
      image: 'pierre-aventurine.png',
      affirmation: 'J\'ouvre mon cœur à la douceur. Je mérite la paix et l\'harmonie.'
    },
    {
      slug: 'cornaline',
      name: 'Cornaline',
      article: 'la ',
      tagline: "L'énergie créatrice, la flamme intérieure",
      reading: "Vous sentez en vous une envie de briller, de créer, de prendre votre place. Votre énergie cherche à s'exprimer avec joie, enthousiasme et confiance.",
      description: "La Cornaline est la pierre qui vous appelle. Elle ravive votre flamme intérieure, stimule votre créativité et vous donne le courage d'avancer avec audace.",
      chakra: { name: 'Sacré', sanskrit: 'Svadhisthana', description: "Le centre de votre créativité, de vos émotions et de votre vitalité." },
      element: { name: 'Feu', description: "Passion, énergie et force de transformation." },
      virtues: ['Vitalité', 'Créativité', 'Confiance'],
      collectionHandle: 'cornaline',
      color: '#c0542b',
      image: 'pierre-cornaline.png',
      affirmation: 'Ma flamme intérieure brûle avec force. Je crée, j\'ose, je rayonne.'
    },
    {
      slug: 'jade',
      name: 'Jade',
      article: 'le ',
      tagline: "L'harmonie, la sagesse ancestrale",
      reading: "Vous ressentez une déconnexion, un besoin de retrouver votre lien avec quelque chose de plus grand que vous. Votre énergie cherche la paix et la sagesse intérieure.",
      description: "Le Jade est la pierre qui vous appelle. Pierre de sagesse et d'harmonie, elle vous accompagne vers un équilibre intérieur profond et une connexion spirituelle authentique.",
      chakra: { name: 'Coeur', sanskrit: 'Anahata', description: "Le centre de votre amour, de votre compassion et de votre équilibre émotionnel." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Harmonie', 'Sagesse', 'Sérénité'],
      collectionHandle: 'nos-bijoux-en-pierre-jade',
      color: '#5a8a5e',
      image: 'pierre-jade.png',
      affirmation: 'Je suis en harmonie avec le monde. La sagesse coule en moi naturellement.'
    },
    {
      slug: 'citrine',
      name: 'Citrine',
      article: 'la ',
      tagline: "L'abondance, la lumière solaire",
      reading: "Vous cherchez à attirer la joie, le succès et l'abondance dans votre vie. Votre énergie a besoin de lumière et d'enthousiasme pour avancer.",
      description: "La Citrine est la pierre qui vous appelle. Pierre du soleil et de l'abondance, elle attire la prospérité et illumine votre chemin de sa chaleur dorée.",
      chakra: { name: 'Plexus solaire', sanskrit: 'Manipura', description: "Le centre de votre volonté, de votre confiance et de votre pouvoir personnel." },
      element: { name: 'Feu', description: "Passion, énergie et force de transformation." },
      virtues: ['Abondance', 'Joie', 'Confiance'],
      collectionHandle: 'citrine',
      color: '#d4a520',
      image: 'pierre-citrine.png',
      affirmation: 'L\'abondance coule vers moi. Je choisis la joie et la lumière chaque jour.'
    },
    {
      slug: 'jaspe-rouge',
      name: 'Jaspe Rouge',
      article: 'le ',
      tagline: "L'ancrage puissant, la force de la terre",
      reading: "Vous vous sentez instable, déraciné(e), ou envahi(e) par le stress. Votre énergie a besoin d'un ancrage profond pour retrouver force et stabilité.",
      description: "Le Jaspe Rouge est la pierre qui vous appelle. Pierre d'ancrage par excellence, elle vous reconnecte à la terre et renforce votre courage face aux défis.",
      chakra: { name: 'Racine', sanskrit: 'Muladhara', description: "Le centre de votre ancrage et de votre stabilité fondamentale." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Ancrage', 'Courage', 'Vitalité'],
      collectionHandle: 'nos-bijoux-en-pierre-jaspe-rouge',
      color: '#8B2500',
      image: 'pierre-jaspe-rouge.png',
      affirmation: 'Je suis ancré(e) dans la terre. Ma force est inébranlable.'
    },
    {
      slug: 'pierre-de-lune',
      name: 'Pierre de Lune',
      article: 'la ',
      tagline: "La douceur féminine, l'intuition lunaire",
      reading: "Vous êtes dans une quête d'éveil intérieur et de calme. Votre énergie a besoin de douceur, d'apaisement mental et de connexion à votre intuition.",
      description: "La Pierre de Lune est la pierre qui vous appelle. Douce et lumineuse, elle accompagne vos cycles intérieurs et éveille votre intuition profonde.",
      chakra: { name: 'Couronne', sanskrit: 'Sahasrara', description: "Le centre de votre connexion spirituelle et de votre éveil intérieur." },
      element: { name: 'Eau', description: "Fluidité, intuition et profondeur émotionnelle." },
      virtues: ['Intuition', 'Douceur', 'Féminité'],
      collectionHandle: 'pierre-de-lune',
      color: '#c9c0d0',
      image: 'pierre-pierre-de-lune.png',
      affirmation: 'J\'accueille mes cycles avec douceur. Mon intuition est mon guide le plus fidèle.'
    },
    {
      slug: 'labradorite',
      name: 'Labradorite',
      article: 'la ',
      tagline: "Le bouclier mystique, la magie intérieure",
      reading: "Vous vous sentez inspiré(e) mais dispersé(e), avec une énergie créative qui cherche sa direction. Vous avez besoin de protection et de canalisation de votre intuition.",
      description: "La Labradorite est la pierre qui vous appelle. Bouclier mystique aux reflets enchanteurs, elle protège votre aura et amplifie vos dons intuitifs.",
      chakra: { name: 'Troisième œil', sanskrit: 'Ajna', description: "Le centre de votre intuition et de votre clairvoyance." },
      element: { name: 'Air', description: "Légèreté, clarté et élévation de l'esprit." },
      virtues: ['Protection', 'Intuition', 'Magie'],
      collectionHandle: 'labradorite',
      color: '#4a6b7a',
      image: 'pierre-labradorite.png',
      affirmation: 'Je suis protégé(e) et guidé(e). Ma magie intérieure se révèle chaque jour.'
    },
    {
      slug: 'pyrite',
      name: 'Pyrite',
      article: 'la ',
      tagline: "L'éclat doré, la volonté inébranlable",
      reading: "Vous vous sentez inspiré(e) mais dispersé(e), avec un besoin de stabilité et de détermination pour concrétiser vos ambitions.",
      description: "La Pyrite est la pierre qui vous appelle. Son éclat doré reflète votre force intérieure et vous aide à manifester vos projets avec confiance et persévérance.",
      chakra: { name: 'Plexus solaire', sanskrit: 'Manipura', description: "Le centre de votre volonté, de votre confiance et de votre pouvoir personnel." },
      element: { name: 'Feu', description: "Passion, énergie et force de transformation." },
      virtues: ['Volonté', 'Abondance', 'Protection'],
      collectionHandle: 'pyrite',
      color: '#b8a042',
      image: 'pierre-pyrite.png',
      affirmation: 'Ma volonté est d\'or. Je manifeste mes rêves avec puissance et persévérance.'
    },
    {
      slug: 'rhodonite',
      name: 'Rhodonite',
      article: 'la ',
      tagline: "La guérison du cœur, l'amour inconditionnel",
      reading: "Vous portez des blessures émotionnelles du passé qui pèsent sur votre cœur. Votre énergie a besoin de guérison, d'amour et d'ouverture pour avancer.",
      description: "La Rhodonite est la pierre qui vous appelle. Pierre de compassion et de guérison émotionnelle, elle répare les blessures du cœur avec douceur.",
      chakra: { name: 'Coeur', sanskrit: 'Anahata', description: "Le centre de votre amour, de votre compassion et de votre équilibre émotionnel." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Guérison', 'Amour', 'Compassion'],
      collectionHandle: 'rhodonite',
      color: '#c4687a',
      image: 'pierre-rhodonite.png',
      affirmation: 'Mon cœur guérit un peu plus chaque jour. Je mérite l\'amour que je donne aux autres.'
    },
    {
      slug: 'apatite',
      name: 'Apatite',
      article: "l'",
      tagline: "La clarté mentale, l'inspiration créative",
      reading: "Vous vous sentez inspiré(e) mais dispersé(e), avec une intuition forte qui cherche à s'exprimer. Votre énergie a besoin de canalisation et de direction.",
      description: "L'Apatite est la pierre qui vous appelle. Elle stimule votre intellect, clarifie vos pensées et canalise votre inspiration vers des réalisations concrètes.",
      chakra: { name: 'Gorge', sanskrit: 'Vishuddha', description: "Le centre de votre communication et de votre expression authentique." },
      element: { name: 'Air', description: "Légèreté, clarté et élévation de l'esprit." },
      virtues: ['Clarté', 'Inspiration', 'Expression'],
      collectionHandle: 'apatite',
      color: '#3a8a9e',
      image: 'pierre-apatite.png',
      affirmation: 'Mon esprit est clair et mon inspiration est sans limites. Je crée avec intention.'
    },
    {
      slug: 'oeil-de-tigre',
      name: 'Oeil de Tigre',
      article: "l'",
      tagline: "Le courage, la confiance en soi",
      reading: "Vous vous sentez instable et vous cherchez à prendre votre place avec assurance. Votre énergie a besoin de stabilité et de courage pour avancer.",
      description: "L'Oeil de Tigre est la pierre qui vous appelle. Pierre de courage et de protection, elle renforce votre confiance en vous et vous protège des énergies négatives.",
      chakra: { name: 'Plexus solaire', sanskrit: 'Manipura', description: "Le centre de votre volonté, de votre confiance et de votre pouvoir personnel." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Courage', 'Protection', 'Confiance'],
      collectionHandle: 'oeil-de-tigre',
      color: '#9a7030',
      image: 'pierre-oeil-de-tigre.png',
      affirmation: 'Je suis courageux(se) et confiant(e). Ma force intérieure me protège à chaque pas.'
    },
    {
      slug: 'hematite',
      name: 'Hématite',
      article: "l'",
      tagline: "L'ancrage absolu, la stabilité retrouvée",
      reading: "Vous vous sentez submergé(e) par le stress et les énergies négatives. Votre énergie a besoin d'un ancrage puissant pour retrouver votre stabilité.",
      description: "L'Hématite est la pierre qui vous appelle. Pierre d'ancrage par excellence, elle vous reconnecte à la terre et dissipe les énergies négatives.",
      chakra: { name: 'Racine', sanskrit: 'Muladhara', description: "Le centre de votre ancrage et de votre stabilité fondamentale." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Ancrage', 'Protection', 'Équilibre'],
      collectionHandle: 'hematite',
      color: '#5c5c5c',
      image: 'pierre-hematite.png',
      affirmation: 'Je suis solidement ancré(e). Mon équilibre est ma plus grande force.'
    },
    {
      slug: 'obsidienne',
      name: 'Obsidienne',
      article: "l'",
      tagline: "Le miroir de vérité, la purification profonde",
      reading: "Vous ressentez le besoin de vous recentrer sur l'essentiel et de vous libérer du stress accumulé. Votre énergie cherche un nettoyage profond et un apaisement.",
      description: "L'Obsidienne est la pierre qui vous appelle. Miroir de l'âme, elle révèle les vérités cachées et purifie votre énergie en profondeur.",
      chakra: { name: 'Racine', sanskrit: 'Muladhara', description: "Le centre de votre ancrage et de votre stabilité fondamentale." },
      element: { name: 'Feu', description: "Passion, énergie et force de transformation." },
      virtues: ['Purification', 'Vérité', 'Protection'],
      collectionHandle: 'nos-bijoux-en-pierre-obsidienne',
      color: '#1a1a2e',
      image: 'pierre-obsidienne.png',
      affirmation: 'Je me libère de tout ce qui n\'est plus vrai. Ma vérité me purifie et me renforce.'
    },
    {
      slug: 'aigue-marine',
      name: 'Aigue-Marine',
      article: "l'",
      tagline: "La sérénité des profondeurs, la communication fluide",
      reading: "Vous ressentez un besoin de clarté, de reconnexion et de fluidité dans votre communication et votre vie intérieure. Votre énergie cherche la paix des profondeurs.",
      description: "L'Aigue-Marine est la pierre qui vous appelle. Comme l'eau claire d'un océan calme, elle apaise votre esprit et libère votre parole authentique.",
      chakra: { name: 'Gorge', sanskrit: 'Vishuddha', description: "Le centre de votre communication et de votre expression authentique." },
      element: { name: 'Eau', description: "Fluidité, intuition et profondeur émotionnelle." },
      virtues: ['Sérénité', 'Communication', 'Clarté'],
      collectionHandle: 'aigue-marine',
      color: '#5b9eae',
      image: 'pierre-aigue-marine.png',
      affirmation: 'Ma parole est fluide et authentique. Je communique avec le cœur.'
    },
    {
      slug: 'oeil-de-faucon',
      name: 'Oeil de Faucon',
      article: "l'",
      tagline: "La vision claire, la perception élargie",
      reading: "Vous vous sentez brouillé(e), en quête de clarté et de direction. Votre énergie a besoin d'une vision plus large et d'une intuition aiguisée.",
      description: "L'Oeil de Faucon est la pierre qui vous appelle. Elle aiguise votre perception, clarifie votre vision intérieure et vous guide vers la sagesse.",
      chakra: { name: 'Troisième œil', sanskrit: 'Ajna', description: "Le centre de votre intuition et de votre clairvoyance." },
      element: { name: 'Air', description: "Légèreté, clarté et élévation de l'esprit." },
      virtues: ['Vision', 'Intuition', 'Clarté'],
      collectionHandle: 'oeil-de-faucon',
      color: '#4a6070',
      image: 'pierre-oeil-de-faucon.png',
      affirmation: 'Ma vision est claire et perçante. Je vois au-delà des apparences.'
    },
    {
      slug: 'jaspe',
      name: 'Jaspe',
      article: 'le ',
      tagline: "La stabilité, l'expression authentique",
      reading: "Vous doutez de vous et vous avez du mal à exprimer ce que vous ressentez. Votre énergie a besoin de confiance et de libération de votre parole.",
      description: "Le Jaspe est la pierre qui vous appelle. Pierre nourricière et stabilisante, elle vous donne le courage de vous exprimer avec assurance et authenticité.",
      chakra: { name: 'Gorge', sanskrit: 'Vishuddha', description: "Le centre de votre communication et de votre expression authentique." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Expression', 'Stabilité', 'Courage'],
      collectionHandle: 'nos-bijoux-en-pierre-jaspe',
      color: '#8a6040',
      image: 'pierre-jaspe.png',
      affirmation: 'Ma voix compte. Je m\'exprime avec assurance et authenticité.'
    },
    {
      slug: 'agate',
      name: 'Agate',
      article: "l'",
      tagline: "L'équilibre, la confiance retrouvée",
      reading: "Vous doutez de vous et vous cherchez à vous exprimer avec plus d'assurance. Votre énergie a besoin d'équilibre et de confiance.",
      description: "L'Agate est la pierre qui vous appelle. Pierre d'équilibre et d'harmonie, elle stabilise votre énergie et renforce votre confiance en votre parole.",
      chakra: { name: 'Gorge', sanskrit: 'Vishuddha', description: "Le centre de votre communication et de votre expression authentique." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Équilibre', 'Confiance', 'Harmonie'],
      collectionHandle: 'nos-bijoux-en-pierre-agate',
      color: '#7a8a8a',
      image: 'pierre-agate.png',
      affirmation: 'Je suis en équilibre. Ma confiance grandit jour après jour.'
    },
    {
      slug: 'amazonite',
      name: 'Amazonite',
      article: "l'",
      tagline: "La paix intérieure, la vérité du cœur",
      reading: "Vous ressentez une déconnexion et une quête d'éveil spirituel. Votre énergie cherche à retrouver un lien profond avec votre vérité et votre spiritualité.",
      description: "L'Amazonite est la pierre qui vous appelle. Pierre de vérité et de sérénité, elle apaise le mental et vous aide à communiquer avec le cœur.",
      chakra: { name: 'Coeur', sanskrit: 'Anahata', description: "Le centre de votre amour, de votre compassion et de votre équilibre émotionnel." },
      element: { name: 'Eau', description: "Fluidité, intuition et profondeur émotionnelle." },
      virtues: ['Sérénité', 'Vérité', 'Communication'],
      collectionHandle: 'amazonite',
      color: '#5aaa9a',
      image: 'pierre-amazonite.png',
      affirmation: 'Je suis connecté(e) à ma vérité. La paix intérieure est mon état naturel.'
    },
    {
      slug: 'jaspe-africain',
      name: 'Jaspe Africain',
      article: 'le ',
      tagline: "La terre nourricière, la parole libérée",
      reading: "Vous manquez de confiance en vous et vous avez du mal à vous exprimer. Votre énergie a besoin de stabilité et de courage pour libérer votre voix.",
      description: "Le Jaspe Africain est la pierre qui vous appelle. Pierre de la terre, elle nourrit votre ancrage et vous donne la force de vous exprimer avec authenticité.",
      chakra: { name: 'Gorge', sanskrit: 'Vishuddha', description: "Le centre de votre communication et de votre expression authentique." },
      element: { name: 'Terre', description: "Solidité, stabilité et enracinement dans le monde concret." },
      virtues: ['Ancrage', 'Expression', 'Confiance'],
      collectionHandle: 'nos-bijoux-en-pierre-jaspe-africain',
      color: '#7a6a4a',
      image: 'pierre-jaspe-africain.png',
      affirmation: 'La terre me nourrit et me porte. Ma parole est libre et vraie.'
    }
  ];

  /* =========================================================
     QUESTIONS
     ========================================================= */
  const QUESTIONS = [
    {
      title: 'Comment vous sentez-vous ces derniers temps ?',
      answers: [
        "Instable, j'ai besoin d'ancrage",
        "Brouillé(e), j'ai besoin de clarté",
        "Émotif(ve), j'ai besoin d'apaisement",
        "Inspiré(e), mais dispersé(e)",
        "Calme, mais en quête d'éveil"
      ]
    },
    {
      title: "Qu'est-ce qui vous bloque en ce moment ?",
      answers: [
        'Le stress ou les énergies négatives',
        'Le doute ou le manque de confiance',
        "Je n'ose pas dire ce que je ressens",
        'Une blessure émotionnelle du passé',
        'Une sensation de déconnexion'
      ]
    },
    {
      title: 'Quelle énergie recherchez-vous ?',
      answers: [
        'De la stabilité et du calme',
        "De la joie et de l'enthousiasme",
        "Plus d'amour et d'ouverture",
        "De l'intuition et de la magie",
        'Un apaisement mental'
      ]
    },
    {
      title: "Dans quel domaine avez-vous envie d'évoluer ?",
      answers: [
        'Prendre ma place et réussir',
        'Aimer sans peur et guérir le cœur',
        "M'exprimer avec assurance",
        "Me recentrer sur l'essentiel",
        'Développer ma spiritualité'
      ]
    },
    {
      title: 'Choisissez un mantra qui vous parle le plus',
      answers: [
        'Je suis solidement ancré(e)',
        'Je rayonne sans peur',
        "J'accueille l'amour avec confiance",
        'Ma parole est libre et claire',
        'Je suis connecté(e) au divin'
      ]
    },
    {
      title: 'Quelle est votre couleur préférée ?',
      answers: [
        'Rouge / Terre',
        'Orange / Chaleur',
        'Jaune / Lumière',
        'Vert / Nature',
        'Bleu / Océan',
        'Violet / Mystique',
        'Blanc / Clair',
        'Noir / Profond'
      ]
    }
  ];

  /* =========================================================
     SCORING MATRIX — answer text → stone slugs that get +1
     ========================================================= */
  const SCORING = {
    // Q1
    "Instable, j'ai besoin d'ancrage": ['malachite','onyx','jaspe-rouge','jaspe','obsidienne','oeil-de-tigre','hematite'],
    "Brouillé(e), j'ai besoin de clarté": ['lapis-lazuli','aigue-marine','oeil-de-faucon'],
    "Émotif(ve), j'ai besoin d'apaisement": ['amethyste','rhodonite'],
    "Inspiré(e), mais dispersé(e)": ['labradorite','pyrite','apatite'],
    "Calme, mais en quête d'éveil": ['pierre-de-lune','amazonite'],
    // Q2
    'Le stress ou les énergies négatives': ['malachite','onyx','jaspe-rouge','obsidienne','hematite'],
    'Le doute ou le manque de confiance': ['jaspe','agate','jaspe-africain'],
    "Je n'ose pas dire ce que je ressens": ['jaspe','agate','jaspe-africain','aigue-marine','amazonite'],
    'Une blessure émotionnelle du passé': ['amethyste','rhodonite'],
    'Une sensation de déconnexion': ['jade','aigue-marine','amazonite'],
    // Q3
    'De la stabilité et du calme': ['aventurine-verte','malachite','oeil-de-tigre','pyrite','hematite'],
    "De la joie et de l'enthousiasme": ['cornaline','citrine'],
    "Plus d'amour et d'ouverture": ['amethyste','rhodonite'],
    "De l'intuition et de la magie": ['lapis-lazuli','labradorite','apatite','aigue-marine','oeil-de-faucon'],
    'Un apaisement mental': ['onyx','pierre-de-lune','obsidienne'],
    // Q4
    'Prendre ma place et réussir': ['malachite','cornaline','citrine','jaspe-rouge','oeil-de-tigre','pyrite'],
    'Aimer sans peur et guérir le cœur': ['amethyste','rhodonite'],
    "M'exprimer avec assurance": ['jaspe','agate','jaspe-africain'],
    "Me recentrer sur l'essentiel": ['aventurine-verte','onyx','obsidienne'],
    'Développer ma spiritualité': ['lapis-lazuli','jade','labradorite','apatite','aigue-marine','oeil-de-faucon','amazonite'],
    // Q5
    'Je suis solidement ancré(e)': ['aventurine-verte','malachite','onyx'],
    'Je rayonne sans peur': ['cornaline'],
    "J'accueille l'amour avec confiance": ['amethyste','rhodonite'],
    'Ma parole est libre et claire': ['jaspe','agate','jaspe-africain'],
    'Je suis connecté(e) au divin': ['lapis-lazuli','jade','pierre-de-lune','labradorite','aigue-marine','amazonite'],
    // Q6
    'Rouge / Terre': ['malachite','jaspe-rouge'],
    'Orange / Chaleur': ['cornaline'],
    'Jaune / Lumière': ['citrine'],
    'Vert / Nature': ['aventurine-verte','jade'],
    'Bleu / Océan': ['lapis-lazuli'],
    'Violet / Mystique': ['amethyste'],
    'Blanc / Clair': ['pierre-de-lune'],
    'Noir / Profond': ['onyx']
  };

  /* =========================================================
     QUIZ ENGINE
     ========================================================= */
  class StoneQuiz {
    constructor(container) {
      this.container = container;
      this.welcomeEl = container.querySelector('[data-quiz-welcome]');
      this.quizEl = container.querySelector('[data-quiz-container]');
      this.analyzingEl = container.querySelector('[data-quiz-analyzing]');
      this.resultEl = container.querySelector('[data-quiz-result]');
      this.progressBar = container.querySelector('[data-quiz-progress]');
      this.stepCounter = container.querySelector('[data-quiz-step-counter]');
      this.backBtn = container.querySelector('[data-quiz-back]');
      this.currentStep = 0;
      this.answers = [];
      this.slides = container.querySelectorAll('[data-quiz-slide]');
      this.totalSteps = QUESTIONS.length;

      this.init();
    }

    init() {
      // Check URL param for direct result
      var params = new URLSearchParams(window.location.search);
      var resultParam = params.get('result');
      if (resultParam) {
        var stone = STONES.find(function(s) { return s.slug === resultParam; });
        if (stone) {
          this.hideAll();
          this.revealResult(stone);
          return;
        }
      }

      // Check sessionStorage for previous result
      var savedResult = sessionStorage.getItem('mb-quiz-result');
      if (savedResult) {
        var savedStone = STONES.find(function(s) { return s.slug === savedResult; });
        if (savedStone) {
          this.hideAll();
          this.revealResult(savedStone);
          return;
        }
      }

      // Show welcome screen
      this.showWelcome();

      // Bind start button
      var startBtn = this.container.querySelector('[data-quiz-start]');
      if (startBtn) {
        startBtn.addEventListener('click', this.startQuiz.bind(this));
      }

      // Bind answer clicks
      this.container.querySelectorAll('[data-quiz-answer]').forEach(function(btn) {
        btn.addEventListener('click', function() { this.handleAnswer(btn); }.bind(this));
      }.bind(this));

      // Bind back button
      if (this.backBtn) {
        this.backBtn.addEventListener('click', this.goBack.bind(this));
      }

      // Bind restart
      this.container.querySelectorAll('[data-quiz-restart]').forEach(function(btn) {
        btn.addEventListener('click', function() { this.restart(); }.bind(this));
      }.bind(this));

      // Bind report CTA smooth scroll
      var reportCta = this.container.querySelector('[data-report-cta]');
      if (reportCta) {
        reportCta.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.getElementById('quiz-full-report');
          if (target) target.scrollIntoView({ behavior: 'smooth' });
        });
      }

      // Scroll animations will be set up when result is revealed
    }

    hideAll() {
      if (this.welcomeEl) this.welcomeEl.style.display = 'none';
      if (this.quizEl) this.quizEl.style.display = 'none';
      if (this.analyzingEl) this.analyzingEl.style.display = 'none';
    }

    showWelcome() {
      this.hideAll();
      if (this.welcomeEl) this.welcomeEl.style.display = '';
    }

    startQuiz() {
      this.hideAll();
      if (this.quizEl) this.quizEl.style.display = '';
      this.showStep(0);
    }

    showStep(index) {
      this.currentStep = index;

      // Update slides
      this.slides.forEach(function(slide, i) {
        slide.classList.remove('quiz-slide--active', 'quiz-slide--prev');
        if (i === index) {
          slide.classList.add('quiz-slide--active');
        } else if (i < index) {
          slide.classList.add('quiz-slide--prev');
        }
      });

      // Update progress bar
      var progress = ((index + 1) / this.totalSteps) * 100;
      if (this.progressBar) {
        this.progressBar.style.width = progress + '%';
      }

      // Update step counter
      if (this.stepCounter) {
        this.stepCounter.textContent = (index + 1) + ' / ' + this.totalSteps;
      }

      // Show/hide back button
      if (this.backBtn) {
        this.backBtn.style.display = index > 0 ? '' : 'none';
      }
    }

    handleAnswer(btn) {
      var answerText = btn.getAttribute('data-quiz-answer');
      var slideIndex = parseInt(btn.closest('[data-quiz-slide]').getAttribute('data-quiz-slide'));

      // Store answer
      this.answers[slideIndex] = answerText;

      // Visual feedback
      var slide = btn.closest('[data-quiz-slide]');
      slide.querySelectorAll('[data-quiz-answer]').forEach(function(b) { b.classList.remove('quiz-answer--selected'); });
      btn.classList.add('quiz-answer--selected');

      // Auto-advance after short delay
      setTimeout(function() {
        if (slideIndex < this.totalSteps - 1) {
          this.showStep(slideIndex + 1);
        } else {
          this.finishQuiz();
        }
      }.bind(this), 350);
    }

    goBack() {
      if (this.currentStep > 0) {
        this.showStep(this.currentStep - 1);
      }
    }

    calculateResult() {
      var scores = {};
      STONES.forEach(function(s) { scores[s.slug] = 0; });

      this.answers.forEach(function(answerText) {
        if (answerText && SCORING[answerText]) {
          SCORING[answerText].forEach(function(slug) {
            scores[slug] = (scores[slug] || 0) + 1;
          });
        }
      });

      // Find highest score — tiebreaker is array order (first stone in STONES array wins)
      var maxScore = 0;
      var winner = STONES[0];
      STONES.forEach(function(stone) {
        if (scores[stone.slug] > maxScore) {
          maxScore = scores[stone.slug];
          winner = stone;
        }
      });

      return winner;
    }

    finishQuiz() {
      // Show analyzing screen
      this.hideAll();
      if (this.analyzingEl) this.analyzingEl.style.display = '';

      // Calculate during the "analyzing" pause
      var stone = this.calculateResult();

      setTimeout(function() {
        sessionStorage.setItem('mb-quiz-result', stone.slug);
        var url = new URL(window.location);
        url.searchParams.set('result', stone.slug);
        window.history.replaceState({}, '', url);

        if (this.analyzingEl) this.analyzingEl.style.display = 'none';
        this.revealResult(stone);
      }.bind(this), 2200);
    }

    revealResult(stone) {
      // Hide quiz & welcome, show result
      this.hideAll();
      if (this.resultEl) {
        this.resultEl.style.display = '';
        this.resultEl.classList.add('quiz-result--visible');
      }

      // Populate stone data into DOM
      this.populateResult(stone);

      // Fetch products (small delay to let Shopify proxy initialize)
      var self = this;
      setTimeout(function() { self.fetchProducts(stone.collectionHandle, stone.name); }, 500);

      // Setup scroll animations now that result is visible
      this.setupScrollAnimations();

      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    populateResult(stone) {
      var r = this.resultEl;
      if (!r) return;

      var setText = function(sel, text) {
        var el = r.querySelector(sel);
        if (el) el.textContent = text;
      };

      setText('[data-result-name]', stone.name);
      setText('[data-result-tagline]', stone.tagline);
      setText('[data-result-reading]', stone.reading);
      // Remove redundant first sentence that repeats the title
      var desc = stone.description;
      var articleCap = stone.article.charAt(0).toUpperCase() + stone.article.slice(1);
      var redundantPrefix = articleCap + stone.name + ' est la pierre qui vous appelle.';
      if (desc.indexOf(redundantPrefix) === 0) {
        desc = desc.substring(redundantPrefix.length).trim();
      }
      setText('[data-result-description]', desc);
      // Stone title with article
      var stoneTitle = r.querySelector('[data-result-stone-title]');
      if (stoneTitle) {
        var articleCap = stone.article.charAt(0).toUpperCase() + stone.article.slice(1);
        stoneTitle.innerHTML = articleCap + '<em>' + stone.name + '</em> est la pierre qui vous appelle';
      }

      // Usage title with article
      var usageTitle = r.querySelector('[data-result-usage-title]');
      if (usageTitle) {
        usageTitle.innerHTML = 'Comment utiliser ' + '<em>' + stone.article + stone.name + '</em>';
      }
      setText('[data-result-chakra-name]', stone.chakra.name);
      setText('[data-result-chakra-sanskrit]', stone.chakra.sanskrit);
      setText('[data-result-chakra-desc]', stone.chakra.description);
      setText('[data-result-element-name]', stone.element.name);
      setText('[data-result-element-desc]', stone.element.description);

      // Virtues list
      var virtuesContainer = r.querySelector('[data-result-virtues]');
      if (virtuesContainer) {
        virtuesContainer.innerHTML = stone.virtues.map(function(v) {
          return '<li class="quiz-result__virtue"><span class="quiz-result__virtue-icon">✓</span> ' + v + '</li>';
        }).join('');
      }

      // Hero title (lighten dark colors for contrast on dark bg)
      var heroTitle = r.querySelector('[data-result-hero-title]');
      if (heroTitle) {
        var nameColor = stone.color;
        if (this.isTooDark(nameColor)) nameColor = this.lightenColor(nameColor, 40);
        heroTitle.innerHTML = 'Votre Guide:<br><span style="color:' + nameColor + '">' + stone.name + '</span>';
      }

      // Hero virtue tags
      var heroVirtues = r.querySelector('[data-result-hero-virtues]');
      if (heroVirtues) {
        heroVirtues.innerHTML = stone.virtues.map(function(v) {
          return '<span class="quiz-result__hero-virtue-tag">' + v + '</span>';
        }).join('');
      }

      // Hero stone image or gradient fallback
      var heroImageContainer = r.querySelector('[data-result-hero-image]');
      var colorPlaceholder = r.querySelector('[data-result-stone-color]');
      if (stone.image && heroImageContainer) {
        var assetBase = window.__mbQuizAssetBase || '/assets/';
        var img = document.createElement('img');
        img.src = assetBase + stone.image;
        img.alt = stone.name;
        img.className = 'quiz-result__hero-stone-img';
        img.style.filter = 'drop-shadow(0 10px 30px ' + stone.color + '80) drop-shadow(0 20px 50px rgba(0,0,0,0.3))';
        if (colorPlaceholder) colorPlaceholder.style.display = 'none';
        heroImageContainer.querySelectorAll('.quiz-result__hero-stone-img').forEach(function(el) { el.remove(); });
        heroImageContainer.appendChild(img);
      } else if (colorPlaceholder) {
        colorPlaceholder.style.background = 'radial-gradient(circle at 35% 35%, ' + this.lightenColor(stone.color, 40) + ' 0%, ' + stone.color + ' 60%, ' + this.darkenColor(stone.color, 30) + ' 100%)';
      }

      // Hero background glow
      var heroGlow = r.querySelector('[data-result-hero-glow]');
      if (heroGlow) {
        heroGlow.style.background = 'radial-gradient(circle, ' + stone.color + ' 0%, transparent 70%)';
      }

      // Stone description background (color gradient, future: image)
      var stoneBg = r.querySelector('[data-result-stone-bg]');
      if (stoneBg) {
        stoneBg.style.background = 'linear-gradient(135deg, ' + this.darkenColor(stone.color, 20) + ' 0%, ' + stone.color + ' 50%, ' + this.darkenColor(stone.color, 35) + ' 100%)';
      }

      // Affirmation
      setText('[data-result-affirmation]', stone.affirmation || '');

      // (usage title is set above via data-result-usage-title)
    }

    lightenColor(hex, percent) {
      var num = parseInt(hex.replace('#', ''), 16);
      var r = Math.min(255, (num >> 16) + Math.round(255 * percent / 100));
      var g = Math.min(255, ((num >> 8) & 0x00FF) + Math.round(255 * percent / 100));
      var b = Math.min(255, (num & 0x0000FF) + Math.round(255 * percent / 100));
      return '#' + (0x1000000 + r * 0x10000 + g * 0x100 + b).toString(16).slice(1);
    }

    isTooDark(hex) {
      var num = parseInt(hex.replace('#', ''), 16);
      var r = (num >> 16);
      var g = (num >> 8) & 0xFF;
      var b = num & 0xFF;
      return (0.299 * r + 0.587 * g + 0.114 * b) < 80;
    }

    darkenColor(hex, percent) {
      var num = parseInt(hex.replace('#', ''), 16);
      var r = Math.max(0, (num >> 16) - Math.round(255 * percent / 100));
      var g = Math.max(0, ((num >> 8) & 0x00FF) - Math.round(255 * percent / 100));
      var b = Math.max(0, (num & 0x0000FF) - Math.round(255 * percent / 100));
      return '#' + (0x1000000 + r * 0x10000 + g * 0x100 + b).toString(16).slice(1);
    }

    setupScrollAnimations() {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      this.container.querySelectorAll('[data-animate]').forEach(function(el) {
        observer.observe(el);
      });
    }

    buildProductCardHtml(product) {
      var image = product.images && product.images[0] ? product.images[0].src : '';
      var price = product.variants[0] ? (parseFloat(product.variants[0].price)).toFixed(2) : '';
      var comparePrice = product.variants[0] && product.variants[0].compare_at_price
        ? (parseFloat(product.variants[0].compare_at_price)).toFixed(2) : '';
      var onSale = comparePrice && parseFloat(comparePrice) > parseFloat(price);

      return '<div class="product-card product-card-style-standard color-inherit">' +
          '<div class="product-card__wrapper h-full">' +
            '<div class="product-card__image-wrapper">' +
              '<a href="/products/' + product.handle + '" tabindex="-1">' +
                '<div class="media-wrapper product-card__image product-card__image--main" style="--aspect-ratio: 1">' +
                  (image ? '<img src="' + image.replace(/\.([^.]+)$/, '_540x.$1') + '" alt="' + product.title + '" loading="lazy" width="540" height="540">' : '') +
                '</div>' +
              '</a>' +
            '</div>' +
            '<div class="product-card__info text-left">' +
              '<h3 class="product-card__title text-pcard-title">' +
                '<a class="reversed-link block" href="/products/' + product.handle + '">' +
                  '<span class="reversed-link__text">' + product.title + '</span>' +
                '</a>' +
              '</h3>' +
              '<div class="product-card__price">' +
                '<div class="f-price' + (onSale ? ' f-price--on-sale' : '') + '">' +
                  '<div class="f-price__regular">' +
                    '<span class="f-price-item f-price-item--regular">' + price + ' €</span>' +
                  '</div>' +
                  '<div class="f-price__sale">' +
                    '<span class="f-price-item f-price-item--sale">' + price + ' €</span>' +
                    (onSale ? '<span class="f-price-item f-price-item--regular"><s>' + comparePrice + ' €</s></span>' : '') +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    renderProductSlider(container, products) {
      if (!container || !products.length) return;

      // 3 or fewer products: static grid (no carousel)
      if (products.length <= 3) {
        container.innerHTML = '<div class="quiz-products-static-grid">' +
          products.map(function(p) { return this.buildProductCardHtml(p); }.bind(this)).join('') +
        '</div>';
        return;
      }

      // 4+ products: Swiper carousel (mobile swipe, desktop static 3-col visible)
      var slidesHtml = products.map(function(product) {
        return '<div class="swiper-slide">' + this.buildProductCardHtml(product) + '</div>';
      }.bind(this)).join('');

      container.innerHTML =
        '<div class="swiper quiz-products-swiper">' +
          '<div class="swiper-wrapper">' + slidesHtml + '</div>' +
          '<div class="swiper-pagination"></div>' +
        '</div>';

      var SwiperClass = (typeof Swiper === 'function') ? Swiper : (typeof FoxTheme !== 'undefined' && FoxTheme.Swiper && typeof FoxTheme.Swiper.Swiper === 'function') ? FoxTheme.Swiper.Swiper : null;
      if (SwiperClass) {
        var swiperEl = container.querySelector('.quiz-products-swiper');
        new SwiperClass(swiperEl, {
          slidesPerView: 1.3,
          spaceBetween: 16,
          grabCursor: true,
          pagination: { el: swiperEl.querySelector('.swiper-pagination'), type: 'progressbar' },
          breakpoints: {
            768: { slidesPerView: 2.3, spaceBetween: 20 },
            1024: { slidesPerView: 3, spaceBetween: 24 }
          }
        });
      }
    }

    async fetchProducts(collectionHandle, stoneName) {

      var grid = this.resultEl.querySelector('[data-result-products]');
      var gridBottom = this.resultEl.querySelector('[data-result-products-bottom]');
      if (!grid) return;

      grid.innerHTML = '<div class="quiz-result__loading">Chargement de vos recommandations...</div>';
      if (gridBottom) gridBottom.innerHTML = '<div class="quiz-result__loading">Chargement...</div>';

      try {
        var apiPath = '/collections/' + collectionHandle + '/products.json?limit=12';
        var response, attempts = 0, maxAttempts = 3;
        while (attempts < maxAttempts) {
          response = await fetch(apiPath);
          if (response.ok) break;
          attempts++;
          if (attempts < maxAttempts) await new Promise(function(r) { setTimeout(r, 1500); });
        }

        if (!response.ok) throw new Error('Collection not found');
        var data = await response.json();
        var products = data.products || [];


        if (products.length === 0) {
          grid.innerHTML = '<p>Recommandations à venir bientôt.</p>';
          if (gridBottom) gridBottom.innerHTML = '';
          return;
        }

        // Render sliders in both locations
        this.renderProductSlider(grid, products);
        if (gridBottom) this.renderProductSlider(gridBottom, products);

        // Show "Découvrir la collection" button only if 4+ products exist
        var collectionBtns = this.resultEl.querySelectorAll('[data-result-collection-btn]');
        collectionBtns.forEach(function(btn) {
          if (products.length >= 4) {
            btn.href = '/collections/' + collectionHandle;
            btn.textContent = 'Tous les bijoux en ' + stoneName;
            btn.style.display = '';
          } else {
            btn.style.display = 'none';
          }
        });

      } catch (err) {

        grid.innerHTML = '<p>Recommandations à venir bientôt.</p>';
        if (gridBottom) gridBottom.innerHTML = '';
      }
    }

    restart() {
      this.answers = [];
      this.currentStep = 0;
      sessionStorage.removeItem('mb-quiz-result');
      var url = new URL(window.location);
      url.searchParams.delete('result');
      window.history.replaceState({}, '', url);

      if (this.resultEl) {
        this.resultEl.style.display = 'none';
        this.resultEl.classList.remove('quiz-result--visible');
      }

      // Reset selected states
      this.container.querySelectorAll('.quiz-answer--selected').forEach(function(el) {
        el.classList.remove('quiz-answer--selected');
      });

      this.showWelcome();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  /* =========================================================
     INIT
     ========================================================= */
  function initQuiz() {
    var el = document.querySelector('[data-mb-quiz]');
    if (el) new StoneQuiz(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuiz);
  } else {
    initQuiz();
  }
})();
